import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/lib/css-base'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import dataciteFooter from '~root/src/components/DataciteFooter.vue?shadow'
window.customElements.define('datacite-footer', wrap(Vue, dataciteFooter))